export default __webpack_public_path__ + "static/media/803.112af7f6.png";